import React from 'react'
import ReactDOM from 'react-dom/client'
import '@/assets/css/index.css'
import App from '@/App'
import { i18nReady } from '@/locales'

async function enableMocking() {
  if (process.env.REACT_APP_ENABLE_MOCK !== 'true') return
  const { worker } = await import('@/mocks/browser')
  return worker.start({
    onUnhandledRequest: 'warn',
    serviceWorker: { url: '/mockServiceWorker.js' },
  })
}

// 当前语言包按需加载（#1224），就绪后再挂载，首屏不闪裸 key；加载彻底失败也照常
// 挂载（显示 key），不能因语言包白屏
Promise.all([enableMocking(), i18nReady.catch(() => undefined)]).then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(<App />)

  const loading = document.getElementById('global-loading')
  if (loading) loading.remove()
})
